import { configMenu } from 'services';
import { getLocalStorage } from 'utils/localStorage';
import { Locale } from 'interfaces/config';

const getLocale = (): Locale => getLocalStorage('defaultLocale') || configMenu?.config?.defaultLocale?.id || 'en';

export default getLocale;
